module.exports = __webpack_public_path__ + "img/credible-level4.c2bc9470.svg";